import {
  AiFillCheckCircle,
  AiFillCheckSquare,
  AiFillStar,
  AiOutlineCheckCircle,
  AiOutlineMinusCircle,
  AiOutlineMinusSquare,
  AiOutlinePlusSquare,
  AiOutlineStar
} from 'react-icons/ai';
import { BsFlag, BsFlagFill } from 'react-icons/bs';
import { FaRegSquare } from 'react-icons/fa';

import { CodeActions, CodeStatuses } from '../../../../../../../../../../../../../constants/codes';
import colors from '../../../../../../../../../../../../../styles/theme/foundation/colors';

const defaultGrey = colors.greyScale['600'];

const ButtonStates = {
  [CodeStatuses.Applied]: {
    [CodeActions.Apply]: {
      icon: AiFillCheckCircle,
      color: colors.success.primary['600']
    },
    [CodeActions.Reject]: {
      icon: AiOutlineMinusCircle,
      color: defaultGrey
    },
    [CodeActions.Suggest]: {
      icon: AiFillCheckSquare,
      color: colors.primaryScale['300']
    },
    [CodeActions.Waive]: {
      icon: BsFlag,
      color: defaultGrey
    },
    [CodeActions.Inquire]: {
      icon: AiOutlineStar,
      color: defaultGrey
    }
  },
  [CodeStatuses.Suggested]: {
    [CodeActions.Apply]: {
      icon: AiOutlineCheckCircle,
      color: colors.success.primary['600']
    },
    [CodeActions.Reject]: {
      icon: AiOutlineMinusCircle,
      color: colors.error.primary['600']
    },
    [CodeActions.Suggest]: {
      icon: AiOutlinePlusSquare,
      color: colors.greyScale['900']
    },
    [CodeActions.Waive]: {
      icon: BsFlag,
      color: defaultGrey
    },
    [CodeActions.Inquire]: {
      icon: AiOutlineStar,
      color: defaultGrey
    }
  },
  [CodeStatuses.Waived]: {
    [CodeActions.Apply]: {
      icon: AiOutlineCheckCircle,
      color: defaultGrey
    },
    [CodeActions.Reject]: {
      icon: AiOutlineMinusCircle,
      color: defaultGrey
    },
    [CodeActions.Suggest]: {
      icon: AiFillCheckSquare,
      color: defaultGrey
    },
    [CodeActions.Waive]: {
      icon: BsFlagFill,
      color: colors.greyScale['900']
    },
    [CodeActions.Inquire]: {
      icon: AiOutlineStar,
      color: defaultGrey
    }
  },
  [CodeStatuses.Default]: {
    [CodeActions.Apply]: {
      icon: AiOutlineCheckCircle,
      color: defaultGrey
    },
    [CodeActions.Reject]: {
      icon: AiOutlineMinusCircle,
      color: defaultGrey
    },
    [CodeActions.Suggest]: {
      icon: FaRegSquare,
      color: defaultGrey
    },
    [CodeActions.Waive]: {
      icon: BsFlag,
      color: defaultGrey
    },
    [CodeActions.Inquire]: {
      icon: AiOutlineStar,
      color: defaultGrey
    }
  },
  [CodeStatuses.RemovalSuggested]: {
    [CodeActions.Apply]: {
      icon: AiOutlineCheckCircle,
      color: colors.success.primary['600']
    },
    [CodeActions.Reject]: {
      icon: AiOutlineMinusCircle,
      color: colors.error.primary['600']
    },
    [CodeActions.Suggest]: {
      icon: AiOutlineMinusSquare,
      color: colors.greyScale['900']
    },
    [CodeActions.Waive]: {
      icon: BsFlag,
      color: defaultGrey
    },
    [CodeActions.Inquire]: {
      icon: AiOutlineStar,
      color: defaultGrey
    }
  },
  [CodeStatuses.Inquiring]: {
    [CodeActions.Apply]: {
      icon: AiOutlineCheckCircle,
      color: defaultGrey
    },
    [CodeActions.Reject]: {
      icon: AiOutlineMinusCircle,
      color: defaultGrey
    },
    [CodeActions.Suggest]: {
      icon: AiFillCheckSquare,
      color: colors.greyScale['900']
    },
    [CodeActions.Waive]: {
      icon: BsFlag,
      color: defaultGrey
    },
    [CodeActions.Inquire]: {
      icon: AiFillStar,
      color: colors.greyScale['900']
    }
  }
};

export default ButtonStates;
